import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map, retry } from "rxjs/operators";
import { CentroProcedure } from "../models/centros/centro-procedure.model";
import { CentrosViewModel } from "../models/centros/centro.model";
import { ApiEnum, HttpDataService } from "./http-data.service";
import { API_ENDPOINTS } from "../constants/api-endpoints.constants";

@Injectable({
	providedIn: "root",
})
export class CentrosService {
	constructor(private readonly httpDataService: HttpDataService) {}

	getCentroById(id: number): Observable<CentrosViewModel> {
		return this.httpDataService
			.get$<CentrosViewModel>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.getById(id),
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentrosViewModel>(
						"getCentro",
					),
				),
			);
	}

	getCentroByCebeId(id: number): Observable<CentroProcedure[]> {
		return this.httpDataService
			.get$<
				CentroProcedure[]
			>(ApiEnum.API_ROOT, API_ENDPOINTS.centro.getByCebes(id))
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentroProcedure[]>(
						"getCentroByCebeId",
					),
				),
			);
	}

	getCentroByContratosId(id: number): Observable<CentroProcedure[]> {
		return this.httpDataService
			.get$<
				CentroProcedure[]
			>(ApiEnum.API_ROOT, API_ENDPOINTS.centro.getByContratos(id))
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentroProcedure[]>(
						"getCentroByContratosId",
					),
				),
			);
	}

	updateCentro(
		centro: CentrosViewModel,
		id: number,
	): Observable<CentrosViewModel> {
		return this.httpDataService
			.put$<CentrosViewModel>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.update(id),
				centro,
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentrosViewModel>(
						"updateCentro",
					),
				),
			);
	}

	createCentro(centro: CentrosViewModel): Observable<CentrosViewModel> {
		return this.httpDataService
			.post$<CentrosViewModel>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.create(),
				centro,
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentrosViewModel>(
						"createCentro",
					),
				),
			);
	}

	exportToExcel(centroId: number): Observable<Blob> {
		return this.httpDataService
			.getFile$<Blob>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.exportToExcel(centroId),
			)
			.pipe(
				retry(3),
				catchError(
					this.httpDataService.handleError<Blob>("exportToExcel"),
				),
			);
	}

	Validate(id: number): Observable<Boolean> {
		return this.httpDataService
			.post$<Boolean>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.validar(id),
				id,
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<Boolean>("Validate"),
				),
			);
	}
	Migrar(id: number): Observable<Boolean> {
		return this.httpDataService
			.post$<Boolean>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.listoMigrar(id),
				id,
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(this.httpDataService.handleError<Boolean>("Migrar")),
			);
	}
}
